import WarningIcon from '@mui/icons-material/Warning';
import { Box, Link } from '@mui/material';
import React from 'react';
import StyledSection from '../styles/StyledSection';
import { Palette } from 'Palette';
import { StyledTypography } from '../styles/styles';
import { FundOpportunityEOIInstance } from './controller';

export function FundOpportunityEOILinkedWarning({
  instance,
}: {
  instance: FundOpportunityEOIInstance;
}): JSX.Element | null {
  const { adminView } = instance.props;
  const linkedOpportunities = instance.state.fundOpportunity?.linkedOpportunities;

  if (!adminView || !linkedOpportunities || linkedOpportunities.length === 0) {
    return null;
  }

  return (
    <StyledSection
      tone="warning"
      bottomSpacing={4}
      leftRightSpacing={0}
      sx={{ marginBottom: '1.875rem' }}
    >
      <Box
        sx={{
          display: 'flex',
          alignItems: 'flex-start',
          gap: 2,
          padding: '1rem',
          backgroundColor: Palette.warning.background,
          border: `1px solid ${Palette.warning.border}`,
          borderRadius: '8px',
        }}
      >
        <WarningIcon
          sx={{
            color: Palette.warning.text,
            marginTop: '2px',
            flexShrink: 0,
          }}
        />
        <Box sx={{ flex: 1 }}>
          <StyledTypography
            variant="h6"
            tone="warning"
            sx={{
              fontWeight: 600,
              marginBottom: '0.5rem',
            }}
          >
            Content Editing Warning
          </StyledTypography>
          <StyledTypography variant="body2" tone="warning" sx={{ marginBottom: '1rem' }}>
            Editing this content will affect the following linked opportunities as well:
          </StyledTypography>
          <Box sx={{ display: 'flex', flexDirection: 'column', gap: 1 }}>
            {linkedOpportunities.map((opportunity) => (
              <Link
                key={opportunity.id}
                href={`/opportunities/${opportunity.id}`}
                sx={{
                  color: Palette.warning.text,
                  textDecoration: 'underline',
                  fontWeight: 500,
                  '&:hover': {
                    color: Palette.warning.activeText,
                  },
                }}
              >
                {opportunity.name}
              </Link>
            ))}
          </Box>
        </Box>
      </Box>
    </StyledSection>
  );
}
